import type { LDFlagSet } from 'launchdarkly-react-client-sdk';

import type { CamelCaseKeys } from '@/types/generics';

const staticFeatureFlags = {
  FUTURES_FCA_INELIGIBLE_FLOW_ENABLED: false,
  INSTITUTION_INDIVIDUAL_FLOW_ENABLED: true,
  INSTITUTION_INDIVIDUAL_FLOW_SOLE_INDIVIDUAL_ENABLED: true,
  THEME_SELECTOR: false,
} as const satisfies Record<string, boolean>;

type FuturesPublicTradingFlag = {
  enabled: boolean;
};

const ldFeatureFlags = {
  'futures-enabled': false,
  'futures-public-trading': {
    enabled: false,
  } as FuturesPublicTradingFlag,
  'institutional-onboarding-enabled': false,
  'nci-priority-flow-enabled': false,
} satisfies LDFlagSet;

export type LdFeatureFlags = CamelCaseKeys<typeof ldFeatureFlags>;

export { ldFeatureFlags, staticFeatureFlags };
